import React from "react";

// import components
import NavItem from "./NavItem";

// import styled components
import { Grid } from "../../styled";
import { NavContainer } from "./styled";

const Nav = () => (
  <NavContainer role="navigation">
    <Grid>
      <ul>
        <NavItem target="about" label="About" />
        <NavItem target="contact" label="Contact" />
        <NavItem target="strategic-lending" label="Builders" />
        <NavItem target="construction-programs" label="Loan Programs" />
        <NavItem target="reviews" label="Reviews" />
        <NavItem target="calculators" label="Calculators" />
        <NavItem target="location" label="Location" />
      </ul>
    </Grid>
  </NavContainer>
);

export default Nav;
